import React from 'react'
import { csx } from '@vtex/admin-ui'

import type { CartItemProps } from '../CartItem'
import { CartItem } from '../CartItem'
import { getCartItemReactKey } from '../../../../utils'
import type { OrderFormItemWithAssemblyItems } from '../../typings'

type CartCardProps = {
  item: OrderFormItemWithAssemblyItems
} & Omit<CartItemProps, 'item' | 'itemIndex'>

export const CartCard = ({
  item: {
    orderFormItem: { item, index },
    assemblyItems,
  },
  currencyCode,
  messages,
  removeCartItem,
  updateCartItem,
}: CartCardProps) => {
  return (
    <div
      data-testid="cart-card-item"
      key={getCartItemReactKey(item.id, index)}
      className={csx({
        ':not(:last-child)': {
          borderBottom: '$neutral',
          paddingBottom: '$space-6',
          marginBottom: '$space-6',
        },
      })}
    >
      <CartItem
        item={item}
        itemIndex={index}
        messages={messages}
        currencyCode={currencyCode}
        removeCartItem={removeCartItem}
        updateCartItem={updateCartItem}
      />
      {assemblyItems?.map((assemblyItem) => (
        <div
          key={getCartItemReactKey(assemblyItem.item.id, assemblyItem.index)}
          className={csx({ paddingTop: '$space-6' })}
        >
          <CartItem
            item={assemblyItem.item}
            itemIndex={assemblyItem.index}
            messages={messages}
            currencyCode={currencyCode}
            removeCartItem={removeCartItem}
            updateCartItem={updateCartItem}
            editionDisabled
          />
        </div>
      ))}
    </div>
  )
}
